module.exports = __webpack_public_path__ + "static/media/fuelsensor3.6c672807.jpg";